import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Clock, ArrowRight } from "lucide-react";

export default function TrialBanner() {
  const { user } = useAuth();
  const sub = user?.subscription_status;
  if (!sub || sub.founding || !sub.is_trial) return null;
  const days = sub.days_left;
  const urgent = days <= 2;
  return (
    <div
      data-testid="trial-banner"
      className={`px-4 py-2 text-xs sm:text-sm flex items-center justify-center gap-3 ${
        urgent ? "bg-[#FEF3F2] text-[#B42318] border-b border-[#D92D20]" : "bg-[#FFFAEB] text-[#B54708] border-b border-[#F79009]"
      }`}
    >
      <Clock size={14} />
      <span>
        <strong className="font-semibold">{days} day{days !== 1 ? "s" : ""} left</strong> on your free trial.
      </span>
      <Link
        to="/app/billing"
        data-testid="trial-banner-cta"
        className="font-semibold underline underline-offset-2 flex items-center gap-1 hover:opacity-80"
      >
        Upgrade now <ArrowRight size={12} />
      </Link>
    </div>
  );
}
